const parseTimestamp = (timestamp) => {
    let d = new Date(timestamp);
    return d.toTimeString().split(" ")[0]
}

const parseFullTimestamp = (timestamp) => {
    if(timestamp === 0) {
        return ""
    }
    let d = new Date(timestamp);
    return (parseTimestamp(timestamp) + " on " + d.toDateString())
}

const sortString = (a, b) => {
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0; // names must be equal
}

export {parseTimestamp, sortString, parseFullTimestamp}
